/**
 * Dialog_exit snippet
 * 
 * @class Snippet_Dialog_exit
 * @extends Snippet_Dialog
 */

Snippet_Dialog_exit = (function(Snippet) {

	var Snippet_Dialog_exit = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Dialog_exit.prototype, Snippet_Dialog.prototype, {
		buttons: [{cls: '', action: 'go-back', label: 'go_back'}, {cls: '', action: 'go-exit', label: 'yes'}],

		/**
		 * @inheritdoc Dialog#renderHeader
		 */
		renderHeader: function(){
			this.$el.append('<div class="title">'+__('dialog_exit_title')+'</div>');
		},

		/**
		 * @inheritdoc Dialog#renderContent
		 */
		renderContent: function(){
			this.$el.append('<div class="content">' + __('dialog_exit_content') + '</div><div class="version">v' + CONFIG.version + '</div>');
		},
		
		/**
		 * @inheritdoc Dialog#renderButtons
		 */
		renderButtons: function(){
			$buttons = $('<ul class="buttons" />');
			var button;
			for(var i = 0; i < this.buttons.length; i++){
				button = this.buttons[i];
				$buttons.append('<li class="focusable button '+ button.cls + '" data-action="' + button.action + '" data-tr="' + __(button.label) + '">' +  __(button.label) + '</li>')
			}
			
			this.$el.append($buttons);
		},
		onEnter: function($el, event) {
			var action = $el.attr("data-action").split('-');
			if(action[1] == 'back'){
				this.onReturn();
			}
			else if(action[1] == 'exit'){
				if(typeof(Android) !== 'undefined') {
					Android.exit();  // Android
				} else {
					this.destroy();
					Device.exit();  // other TV platforms
                    window.close();
				}
                /*var userAgent = navigator.userAgent;
				var smarttv_platform = [];
				substr_pos = userAgent.search(/SmartTvA/i);
				if (substr_pos > -1) {
				smarttv_platform["type"]=userAgent;
					smarttv_platform["manufacturer"]="Smart TV Alliance";
					smarttv_platform["version"]=userAgent.substr(substr_pos+9,6);
					smarttv_platform["major"]=parseInt(smarttv_platform["version"].split('.')[0]);
					smarttv_platform["minor"]=parseInt(smarttv_platform["version"].split('.')[1]);
					smarttv_platform["revision"]=parseInt(smarttv_platform["version"].split('.')[2]);
				}
				if (typeof SmartTvA_API!= "undefined"&& smarttv_platform["major"] >= 3) {
					SmartTvA_API.exit();
				} else {
					window.history.go(-999);
					window.close();
				}*/
			}
			
			return false;
		},
		onClose: function() {
			this.onReturn();
		}
	});

	return Snippet_Dialog_exit;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/dialog_exit.js
// module id = 68
// module chunks = 0